import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Button, Col, Row } from "reactstrap";
import { graphql, Link } from "gatsby";
import styled from "styled-components";
import { Layout } from "../components";
import Separator from "../components/separator/separator";

const CoolButton = styled(Button)`
  transition: all ease-out 0.2s !important;
  color: var(--textNormal);
  &:hover {
    box-shadow: 0 6px 18px #27282218 !important;
    transform: translateY(-2px);
    color: var(--textNormal);
  }
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
`;

class ArchivePage extends Component {
  render() {
    const { data } = this.props;
    return (
      <Layout>
        <Row>
          <Col xs={12} className="pt-5 pb-4">
            <Separator
              title={`${data.allMarkdownRemark.edges.length} available articles`}
            />
          </Col>
          {data.allMarkdownRemark.edges.map((edge, index) => (
            <Col key={index} xs={12} className="py-3">
              <Link
                to={edge.node.frontmatter.path}
                style={{ fontSize: "1.3em" }}
              >
                {edge.node.frontmatter.title}
              </Link>
              <small className="text-black-50">
                &nbsp;&nbsp;&nbsp;{edge.node.frontmatter.date}
              </small>
              <br />
              {edge.node.frontmatter.tags.split(",").map((tag) => (
                <small className="mr-2 badge badge-light shadow-sm border border-light p-1">{tag}</small>
              ))}
            </Col>
          ))}
          <Col xs={12} className="py-3 text-right">
            <Link to="/">
              <CoolButton className="back-button" color="#fff">
                &nbsp;
                <i className="fas fa-arrow-left" /> &nbsp;Go back&nbsp;
              </CoolButton>
            </Link>
          </Col>
        </Row>
      </Layout>
    );
  }
}

ArchivePage.propTypes = {
  data: PropTypes.object,
};

export default ArchivePage;

export const query = graphql`
  query ArchiveQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          timeToRead
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            thumbnailText
            path
            image
            tags
          }
        }
      }
    }
  }
`;
